var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40843 13.5915C7.61738 13.8006 7.86548 13.9664 8.13855 14.0796C8.41163 14.1928 8.70433 14.251 8.99993 14.251C9.29552 14.251 9.58822 14.1928 9.8613 14.0796C10.1344 13.9664 10.3825 13.8006 10.5914 13.5915L12.9997 11.1833C13.1288 11.0404 13.1981 10.8535 13.1931 10.661C13.1882 10.4685 13.1094 10.2853 12.9731 10.1494C12.8368 10.0134 12.6535 9.93499 12.461 9.93045C12.2685 9.92592 12.0817 9.99558 11.9392 10.125L9.74468 12.3202L9.74993 0.75C9.74993 0.551088 9.67091 0.360322 9.53026 0.21967C9.3896 0.0790176 9.19884 0 8.99993 0C8.80101 0 8.61025 0.0790176 8.4696 0.21967C8.32894 0.360322 8.24993 0.551088 8.24993 0.75L8.24318 12.306L6.06068 10.125C5.91995 9.98437 5.72911 9.9054 5.53016 9.90547C5.33121 9.90554 5.14043 9.98464 4.9998 10.1254C4.85917 10.2661 4.7802 10.4569 4.78027 10.6559C4.78034 10.8548 4.85944 11.0456 5.00018 11.1862L7.40843 13.5915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12C17.0511 12 16.8603 12.079 16.7197 12.2197C16.579 12.3603 16.5 12.5511 16.5 12.75V15.75C16.5 15.9489 16.421 16.1397 16.2803 16.2803C16.1397 16.421 15.9489 16.5 15.75 16.5H2.25C2.05109 16.5 1.86032 16.421 1.71967 16.2803C1.57902 16.1397 1.5 15.9489 1.5 15.75V12.75C1.5 12.5511 1.42098 12.3603 1.28033 12.2197C1.13968 12.079 0.948912 12 0.75 12C0.551088 12 0.360322 12.079 0.21967 12.2197C0.0790176 12.3603 0 12.5511 0 12.75L0 15.75C0 16.3467 0.237053 16.919 0.65901 17.341C1.08097 17.7629 1.65326 18 2.25 18H15.75C16.3467 18 16.919 17.7629 17.341 17.341C17.7629 16.919 18 16.3467 18 15.75V12.75C18 12.5511 17.921 12.3603 17.7803 12.2197C17.6397 12.079 17.4489 12 17.25 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.028c9bf9e9e47f42857a6bc3ff901614.svg";
export { ForwardRef as ReactComponent };